export default "__VITE_ASSET__m4Iym9NZ__"